'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024$002dCat$00241 from "./samples.-Ad-Hoc$package$-Cat$1.js";
var $p;
/** @constructor */
function $c_Lsamples_AdHoc$package$$anon$13(evaluator$10) {
  this.KC = null;
  this.KC = evaluator$10;
}
export { $c_Lsamples_AdHoc$package$$anon$13 as $c_Lsamples_AdHoc$package$$anon$13 };
$p = $c_Lsamples_AdHoc$package$$anon$13.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_AdHoc$package$$anon$13;
/** @constructor */
function $h_Lsamples_AdHoc$package$$anon$13() {
}
export { $h_Lsamples_AdHoc$package$$anon$13 as $h_Lsamples_AdHoc$package$$anon$13 };
$h_Lsamples_AdHoc$package$$anon$13.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.KC.h();
  return ((v instanceof $j_samples$002e$002dAd$002dHoc$0024package$0024$002dCat$00241.$c_Lsamples_AdHoc$package$Cat$1) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_AdHoc$package$$anon$13 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_AdHoc$package$$anon$13, "samples.AdHoc$package$$anon$13", ({
  o1: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_AdHoc$package$$anon$13 as $d_Lsamples_AdHoc$package$$anon$13 };
